import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, Clock } from 'lucide-react';
import api from '../../services/api'; // Assuming an api service for authenticated requests
import LoadingSpinner from '../../components/UI/LoadingSpinner';

const HistoryPage = () => {
  const [sessions, setSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        setIsLoading(true);
        // The backend endpoint to list chat sessions is /api/ai/chats
        const response = await api.get('/ai/chats');
        setSessions(response.data.sessions || []);
        setError(null);
      } catch (err) {
        setError('Failed to fetch chat history. Please make sure you are logged in.');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSessions();
  }, []);

  const formatDate = (ts) => {
    if (!ts) return 'N/A';
    return new Date(ts * 1000).toLocaleString();
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-3xl font-bold text-gray-800">Chat History</h1>
        <p className="text-gray-500 mt-2">Review your past conversations.</p>
      </div>

      {isLoading && <div className="flex justify-center"><LoadingSpinner size="lg"/></div>}
      {error && <div className="card bg-red-100 text-red-700 p-4">{error}</div>}

      {!isLoading && !error && (
        <div className="space-y-4">
          {sessions.length > 0 ? (
            sessions.map((session) => (
              <Link 
                to={`/history/${session.sessionId}`} 
                key={session.sessionId} 
                className="card bg-white hover:bg-gray-50 transition-all duration-200 block p-4 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <MessageSquare className="h-6 w-6 text-primary-500" />
                    <p className="font-medium text-gray-700 truncate">
                      {session.first_message?.text || 'Untitled Conversation'}
                    </p>
                  </div>
                  <div className="flex items-center space-x-2 text-sm text-gray-400">
                    <Clock className="h-4 w-4" />
                    <span>{formatDate(session.last_message?.ts)}</span>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <div className="text-center py-12 card bg-gray-50">
              <MessageSquare className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-lg font-medium text-gray-900">No History Found</h3>
              <p className="mt-1 text-sm text-gray-500">Your past conversations will appear here.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HistoryPage;
